var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InfiniteLoading',{ref:"infiniteLoading",attrs:{"spinner":_vm.spinner},on:{"infinite":_vm.infiniteHandler}},[_c('div',{attrs:{"slot":"no-more"},slot:"no-more"}),_c('div',{attrs:{"slot":"no-results"},slot:"no-results"},[_vm._v("조회 결과가 없습니다.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }